import TagManager from 'react-gtm-module'

import { Product } from '../types/Product'
import { emptyEcomDataLayer } from './utils'

interface SelectProductColorVariantParams {
  selectedVariantProduct: Product
  selectedVariantType: 'color' | 'size'
  currentProduct: Product
  variantValue: string
  totalVariantsAvailable: number
  variantPosition: number
  getLocalizedProductUrl: (product?: Product) => string
}

const selectProductColorVariant = (params: SelectProductColorVariantParams) => {
  const {
    selectedVariantProduct,
    selectedVariantType,
    variantValue,
    currentProduct,
    totalVariantsAvailable,
    variantPosition,
    getLocalizedProductUrl,
  } = params

  emptyEcomDataLayer() // First empty datalayer
  TagManager.dataLayer({
    dataLayer: {
      event: 'select_product_variant',
      product_id: currentProduct['product.code'],
      selected_variant_type: selectedVariantType,
      selected_variant_value: variantValue,
      total_variants_available: totalVariantsAvailable,
      variant_position: variantPosition,
      product_url: getLocalizedProductUrl(selectedVariantProduct),
    },
  })
}

export default selectProductColorVariant
